const experience = [
    {
        id: 1,
        jobTitle:"Instructional Team",
        duration:"Nov 2021 - Present",
        company:"Kodecoon Academy", 
        location: "Singapore (Remote)",
        point1:"Managed products and process-improvement projects together with the Curriculum Team.",
        point2:"Developed follow-up materials to increase customer retention by 40%.",
        point3:"Work closely with lead instructors to provide parents with meaningful and prompt feedback on the students’ progress."
    },
    {
        id: 2,
        jobTitle:"Product Team",
        duration:"Feb 2018 - Nov 2021",
        company: "Saturday Kids",
        location:"Singapore",
        point1:"Led product strategy for the team and implemented more than 8 courses which led to an increase in overall yearly revenue.",
        point2:"Spearheaded the development of the training process and procedures internally for the Instructional Team leading to a reduction of training time by 50%.",
        point3:"Developed an internal ATS system to streamline and automate 60% of the HR process using Airtable."
    },
    {
        id: 3, 
        jobTitle:"Special Projects",
        duration:"May 2015 - Feb 2016",
        company:"Glints",
        location:"Singapore",
        point1:"Managed a team of freelance writers and editors, and liaised with clients and stakeholders.",
        point2:"Planned and executed several marketing campaigns for clients which led to an increase in applicants hired by 30%.",
        point3:"Developed and launched the company’s blog to increase audience reach by 60%."
    },
]

export default experience